// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.layered {
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.layered-no-overlap {
  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);
}

.no-gutter > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.toggle-task-rollover {
  display: flex;
  border-top: 0.1rem solid #c0c0c0;
  padding-top: 0.6rem;
  margin-top: 0.1rem;
}
.toggle-task-rollover .artful-checkbox-wrapper {
  min-height: 2.2rem;
  width: 100%;
  padding-left: 0 !important;
}
.toggle-task-rollover .artful-checkbox-wrapper label {
  width: 100%;
  height: 100%;
  font-weight: normal !important;
  font-size: 1.4rem;
  margin-left: 0.1rem;
}
.toggle-task-rollover .artful-checkbox-wrapper label:before {
  top: -0.1rem;
  font-size: 2.2rem !important;
  margin-right: 10px;
  content: "\\f058" !important;
}

.repeat-rule-popup .toggle-task-rollover input[type=checkbox] + label {
  padding-left: 2.6rem !important;
  margin-left: 0 !important;
  line-height: 2rem !important;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Calendar/RepeatRule/ToggleTaskRollover.scss","webpack://./src/Styles/Material.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gFAAA;ADKF;;ACFA;EACE,gBAAA;EACA,eAAA;ADKF;;AAXA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;AAcF;AAZE;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;AAcJ;AAZI;EACE,WAAA;EACA,YAAA;EAEA,8BAAA;EACA,iBAAA;EACA,mBAAA;AAaN;AAVI;EACE,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;AAYN;;AARA;EACE,+BAAA;EACA,yBAAA;EACA,4BAAA;AAWF","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n@import 'Material.scss';\n\n.toggle-task-rollover {\n  display: flex;\n  border-top: 0.1rem solid #c0c0c0;\n  padding-top: 0.6rem;\n  margin-top: 0.1rem;\n\n  .artful-checkbox-wrapper {\n    min-height: 2.2rem;\n    width: 100%;\n    padding-left: 0 !important;\n\n    label {\n      width: 100%;\n      height: 100%;\n      // font-weight: 500 !important;\n      font-weight: normal !important;\n      font-size: 1.4rem;\n      margin-left: 0.1rem;\n    }\n\n    label:before {\n      top: -0.1rem;\n      font-size: 2.2rem !important;\n      margin-right: 10px;\n      content: '\\f058' !important;\n    }\n  }\n}\n.repeat-rule-popup .toggle-task-rollover input[type='checkbox'] + label {\n  padding-left: 2.6rem !important;\n  margin-left: 0 !important;\n  line-height: 2rem !important;\n}\n",".layered {\n  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.layered-no-overlap {\n  box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.19), 0 0.6rem 0.6rem rgba(0, 0, 0, 0.23);\n}\n\n.no-gutter > [class*='col-'] {\n  padding-right: 0;\n  padding-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
